import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import { SummaryInfoDto } from 'src/app/web/interfaces/project/list/summaryInfoDto';
import { ViewProjectPayDto } from 'src/app/web/interfaces/project/list/viewProjectPayDto';
import { FormatDataTableGlobalFive } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 

@Component({
  selector: 'app-summary-information',
  templateUrl: './summary-information.component.html',
  styleUrls: ['./summary-information.component.scss']
})
export class SummaryInformationComponent implements  OnInit {

  closeResult = '';
  item: ViewProjectPayDto

  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;

  dtOptions: DataTables.Settings = {};

  private apiService: ApiServiceProject;
  summaryInfoDto: SummaryInfoDto = {} as SummaryInfoDto
  
  constructor(config: NgbModalConfig, private modalService: NgbModal, private http: HttpClient,
    private spinner: NgxSpinnerService, private errorService:ErrorService) {

    config.backdrop = 'static';
    config.keyboard = false;
   }

  ngOnInit(): void {
    this.dtOptions = FormatDataTableGlobalFive();

    this.apiService =  new ApiServiceProject(this.http);
  }

  public open(id:number) {

    this.spinner.show();

    this.summaryInfoDto.listAssigned = []


    this.apiService.getService("project-info?id_project="+id).subscribe({
      next: (rs:any) => {

        if(rs.code == null){
          this.summaryInfoDto = rs

          this.spinner.hide()
        }else{
          this.spinner.hide()
          Swal.fire({title:rs.erro,text: '',icon: 'error',heightAuto: false});
        }
      
      },
      error: (error) => {
        this.errorService.error(error);
      }
    });


    this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}

